import {connectToStores} from 'epic-alt-utils';
import FriendInviteActions from 'epic-fortnite-react/actions/FriendInviteActions';
import {generatePath} from 'epic-fortnite-react/utils/FortniteUtils';
import PropTypes from 'prop-types';
import queryString from 'query-string';
import React from 'react';
import {withRouter} from 'react-router';

import {FriendInviteStore, LoginStore, AppConfigStore} from '../../stores';

@connectToStores
class FriendInviteModal extends React.Component {
  static propTypes = {
    friendInviteStore: PropTypes.object,
    loginStore: PropTypes.object,
    appConfigStore: PropTypes.object,
    history: PropTypes.object,
  };

  static getStores() {
    return [AppConfigStore, FriendInviteStore, LoginStore];
  }

  static getPropsFromStores() {
    return {
      friendInviteStore: FriendInviteStore.getState(),
      loginStore: LoginStore.getState(),
      appConfigStore: AppConfigStore.getState(),
    };
  }

  componentDidUpdate(prevProps) {
    const showModal = this.props.friendInviteStore.enableModal;
    const prevShowModal = prevProps.friendInviteStore.enableModal;
    const overlay = this.friendText;
    const container = this.friendContainer;
    if (overlay && showModal && !prevShowModal) {
      this.enterAnimation(overlay, container);
      const search = queryString.parse(this.props.history.location.search);
      search.friendLink = true;
      this.props.history.replace(generatePath(this.props.history.location.pathname, search));
    }
  }

  enterAnimation = (item, container) => {
    console.log(item, container);
    const tl = new TimelineMax({paused: true});
    tl.fromTo(container, 0.5, {autoAlpha: 0}, {autoAlpha: 1, clearProps: 'all'});
    tl.fromTo(
      item,
      0.7,
      {y: 50, autoAlpha: 0},
      {
        y: '-50%',
        autoAlpha: 1,
        ease: Elastic.easeOut.config(1, 0.5),
        clearProps: 'all',
      },
      '-=0.3'
    );
    tl.play();
  };

  closeModal = () => {
    const container = this.friendContainer;
    TweenMax.to(container, 0.5, {autoAlpha: 0, onComplete: this.closeComplete});
  };

  closeComplete = () => {
    FriendInviteActions.hideModal();
    const searchString = queryString.parse(this.props.history.location.search);
    delete searchString.friendLink;
    this.props.history.replace(generatePath(this.props.history.location.pathname, searchString));
  };

  render() {
    const {friendInviteStore, loginStore, appConfigStore} = this.props;
    const showModal = friendInviteStore.enableModal;
    //hide Modal
    if (!showModal || !loginStore.isLoggedIn || !appConfigStore.friendLinkEnabled) return <div />;
    //show Modal
    const data = friendInviteStore.friendInvite.modal;
    const friend = loginStore.accountInfo.displayName || loginStore.accountInfo.id;
    const url = `${appConfigStore.friendUrl}${encodeURIComponent(friend)}`;

    return (
      <div>
        <div
          ref={(c) => {
            this.friendContainer = c;
          }}
          className="friend-invite-overlay text-center">
          <div
            ref={(c) => {
              this.friendText = c;
            }}
            className="container-fluid sharelink-container">
            <div className="row">
              <div className="col-xs-12 text-right">
                <div role="presentation" className="close-button" onClick={this.closeModal}>
                  <i className="icon-x" />
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-xs-12">
                <h1>{data.title}</h1>
                <h3>{data.copy}</h3>
                <i className="icon-down-arrow" />
                <div className="note" dangerouslySetInnerHTML={{__html: data.note}} />
              </div>
            </div>
            <div className="row">
              <div className="form-group">
                <div className="col-xs-12">
                  <input
                    type="url"
                    className="form-control input-lg input-link"
                    readOnly
                    defaultValue={url}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(FriendInviteModal);
